module.exports = __webpack_public_path__ + "static/1306672291-exit.aee73a13.jpg";